import AuthCarousel from "../../ui/AuthCarousel";

export default function AuthLayout({ children }) {
  return (
    <div className="flex flex-col sm:flex-row w-full min-h-screen overflow-hidden space-y-2">
      <div className="w-full h-full sm:w-1/2 bg-white-900 text-white-50 flex items-center justify-center overflow-hidden md:block">
        <AuthCarousel />
      </div>
      <div className="w-full h-full sm:w-1/2 flex items-center justify-center p-4">
        {children}
      </div>
    </div>
  );
}
